module.exports = __webpack_public_path__ + "files/85b031dbbebe380f6eb4ece66080d0e7.png";